import { useContext } from 'react'
import { AuthContext } from '@/layout/Auth'

export const isAdmin = (perm: string) => {
  return perm.indexOf('平台') > -1 && perm.indexOf('管理空间信息') > -1
}

const veiwNotification = (perm: string) => {
  return perm.indexOf('平台') > -1 && perm.indexOf('查看告警') > -1
}

export const usePermission = () => {
  const perms = []
  const { authInfo } = useContext(AuthContext)
  const permissions = authInfo?.permissions

  const admin = permissions?.findIndex((perm) => isAdmin(perm.name)) !== -1
  if (admin) {
    perms.push('admin')
  }
  const alarm =
    permissions?.findIndex((perm) => veiwNotification(perm.name)) !== -1
  if (alarm) {
    perms.push('alarm')
  }

  return perms
}
